import { render, staticRenderFns } from "./AlertCertificato.vue?vue&type=template&id=7884b5b9&scoped=true&"
import script from "./AlertCertificato.vue?vue&type=script&lang=js&"
export * from "./AlertCertificato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884b5b9",
  null
  
)

export default component.exports